<template>
  <v-dialog v-model="showingDialog" width="500">
    <!-- The floating action button to open the dialog -->
    <template #activator="{ on }">
      <v-slide-x-reverse-transition>
        <v-btn
          v-if="selectedClassificationsForMerge.length"
          v-on="on"
          bottom
          color="purple"
          dark
          fixed
          right
          round
        >
          <v-icon>merge_type</v-icon>
          <span>UNIR {{ selectedClassificationsForMerge.length }} clasificaciones</span>
        </v-btn>
      </v-slide-x-reverse-transition>
    </template>
    <!-- A component to select the classification to keep and move all the others' data to this one -->
    <v-card>
      <v-container class="px-3 pt-2 pb-3">
        <v-select
          v-model="classificationIdToKeep"
          append-outer-icon="send"
          @click:append-outer="mergeAndCloseDialog"
          hide-details
          item-text="name"
          item-value="id"
          :items="selectedClassificationsForMerge"
          label="Selecciona la clasificación que hay mantener"
          :loading="loadingMergeClassifications"
        />
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapActions, mapState } = createNamespacedHelpers("classifier");

export default {
  data: () => ({
    classificationIdToKeep: null,
    showingDialog: false
  }),
  computed: {
    ...mapState([
      "loadingMergeClassifications",
      "selectedClassificationsForMerge"
    ])
  },
  methods: {
    ...mapActions(["mergeClassifications"]),
    /**
     * Dispatch the merge action and close the dialog after it.
     */
    async mergeAndCloseDialog() {
      await this.mergeClassifications(this.classificationIdToKeep);
      this.showingDialog = false;
    }
  }
};
</script>